import {apiAction} from 'apa/actions'
import * as types from 'customers/actions/types'
import { BaseUrl } from '../../BaseUrl/BaseUrl'

export const add = (contact) => dispatch => dispatch(
  apiAction({
    url: `${BaseUrl}/api/contacts/`,
    method: 'POST',
    data: contact,
    onSuccess: contact => {
      return {
        type: types.CONTACT_CREATE,
        contact: contact
      }
  }
  })
)

export const update = (contact) => dispatch => dispatch(
  apiAction({
    url: `${BaseUrl}/api/contacts/${contact.id}/`,
    method: 'PATCH',
    data: contact,
    onSuccess: contact => ({
      type: types.CONTACT_UPDATE,
      contact: contact
    })
  })
)

export const remove = (contact) => dispatch => dispatch(
  apiAction({
    url: `${BaseUrl}/api/contacts/${contact.id}/`,
    method: 'DELETE',
  })
)